import React from "react";

type TQuestionCopyProps = {
  name: string;
  label?: string;
  note?: string;
};

const QuestionCopy: React.FC<TQuestionCopyProps> = ({ name, label, note }) => (
  <>
    {label && (
      <label className="h4" htmlFor={name}>
        {label}
      </label>
    )}
    {note && <p>{note}</p>}
  </>
);

export default QuestionCopy;
